export class Bank {
  BankId: string;
  BankName: string;
  imageData: string;
  PayingAgentIdForImage: number;
  BankAccountTypes = new Array<BankAccountType>();
  BankRating: string;
  Rate: number;
  RequestCureencyCode: string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class BankAccountType {
  AccountNumberMinimumLength: number;
  AccountType: string;
  AccountNumberMaximumLength: number;
  AccountNumberPrefix: string;
  PayingAgents = new Array<PayingAgent>();
  Validations = new Array<any>();
}

export class PayingAgent {
  IsFundSourceRequired: boolean;
  IsBeneficiaryIdentificationRequired: boolean;
  IsBankCityRequired: boolean;
  BankAccountValidationCallAvailable: boolean;
  AvailabilityDate: string;
  FeeRateDetails = new Array<FeeRateDetail>();
  IsBankNameRequired: boolean;
  IsBankCodeRequired: boolean;
  IsBeneficiaryAddressRequired: boolean;
  IsBeneficiaryValidAddressRequired: boolean;
  IsBeneficiaryPhoneRequired: boolean;
  IsBeneficiaryLastName2Required: boolean;
  IsBeneficiaryRelationRequired: boolean;
  IsCustomerEmployerRequired: boolean;
  IsBeneficiaryZipCodeRequired: boolean;
  IsCustomerOccupationRequired: boolean;
  LocationId: number;
  MaximumLocalAmountExcludeFee?: boolean;
  LocationBranchNumber: string;
  LocationAddress1: string;
  IsTransferReasonRequired: boolean;
  LocationAddress2: string;
  LocationCountryCode: string;
  LocationCity: string;
  LocationDirections: string;
  LocationNotes: string;
  LocationLongitude: null;
  LocationLatitude: null;
  LocationName: string;
  LocationStateCode: string;
  LocationPostalCode: string;
  MaximumLocalAmount?: number;
  PayingAgentRating: number;
  PayingAgentId: number;
  MinimumDenomination?: number;
  PayingAgentName: string;
  PickupRequirements?: string;
  ScheduleThisWeek = new Array<ScheduleThisWeek>();
  Restrictions?: string;
  ScheduleThisWeek2: any[];
  SpecialInstructions?: string;
}

export class FeeRateDetail {
  ExceedsDrawerLimit: boolean;
  ProgramId: number;
  CustomerFee: number;
  ExceedsPremiseLimit: boolean;
  RateCustomer: number;
}

export class ScheduleThisWeek {
  IsOpen: boolean;
  ClosingTime: string;
  OpeningTime: string;
}



// WEBPACK FOOTER //
// ./src/app/models/sendmoney/bankAccount.ts